/**
 * useCamera — shared constants
 */

// CSS keyframes for the focus ring animation
export const focusRingKeyframes = `
@keyframes cameraFocusRing {
  0% { transform: scale(1.5); opacity: 0; }
  30% { transform: scale(1); opacity: 1; }
  70% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.85); opacity: 0; }
}
/* Lock body scroll and prevent orientation-change layout jumps */
body.camera-modal-open {
  overflow: hidden !important;
  touch-action: none;
  position: fixed;
  width: 100%;
  height: 100%;
}
`;

// localStorage keys
export const TORCH_PREF_KEY = 'camera_torch_enabled';
export const AUTO_CAPTURE_PREF_KEY = 'camera_auto_capture_enabled';
export const AUTO_TORCH_PREF_KEY = 'camera_torch_mode';
export const AUTO_ZOOM_PREF_KEY = 'camera_auto_zoom_enabled';
